import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import UserApi from '@/api/user'

export default {
  state: {
    profile: [],
    userRoles: []
  },
  mutations: {
    [MUTATION_TYPE.setProfile]: (state, profile) => {
      state.profile = profile
    },
    [MUTATION_TYPE.setUserRoles]: (state, userRoles) => {
      state.userRoles = userRoles
    }
  },
  actions: {
    [ACTION_TYPE.fetchProfile]: ({ commit }, userId) => new Promise((resolve) => {
      UserApi.getProfile(userId).then((response) => {
        commit('setProfile', response.data)
        resolve()
      }).catch((error) => {
        resolve(error)
      })
    }),
    [ACTION_TYPE.releaseStudent]: (_, id) => new Promise((resolve) => {
      UserApi.releaseStudent(id).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        resolve(error.response)
      })
    }),
    [ACTION_TYPE.fetchUserRoles]: ({ commit }) => new Promise((resolve) => {
      UserApi.getUserRoles().then((response) => {
        commit('setUserRoles', response.data.roles)
        resolve()
      })
    }),
    [ACTION_TYPE.updateProfile]: (_, profile) => new Promise((resolve) => {
      UserApi.updateProfile(profile).then((data) => {
        resolve(data)
      }).catch((error) => {
        resolve(error.response)
      })
    }),
    [ACTION_TYPE.changePassword]: (_, passwords) => new Promise((resolve) => {
      UserApi.changePassword(passwords).then((data) => {
        resolve(data)
      }).catch((errors) => {
        resolve(errors.response)
      })
    })
  },
  getters: {
    [GETTER_TYPE.getProfile]: (state) => state.profile,
    [GETTER_TYPE.getUserRoles]: (state) => state.userRoles
  }
}
